import { render, staticRenderFns } from "./KhlAiOrderListContent.vue?vue&type=template&id=6a8888f6&scoped=true&"
import script from "./KhlAiOrderListContent.vue?vue&type=script&lang=js&"
export * from "./KhlAiOrderListContent.vue?vue&type=script&lang=js&"
import style0 from "./KhlAiOrderListContent.vue?vue&type=style&index=0&id=6a8888f6&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a8888f6",
  null
  
)

export default component.exports